import React, {type JSX} from 'react';
import {Container} from '@mui/material';
import {Grid} from '@mui/system';
import {styled} from '@mui/material/styles';
import {InfoBlock, MedicalRecordsRequestForm} from '../components';
import {Description} from '../components/shared';

const StyledContainer = styled(Container)(({theme}) => ({
  paddingBottom: theme.spacing(10),
}));

const StyledGridWrapper = styled('div')(({theme}) => ({
  paddingTop: theme.spacing(10),
}));

const StyledInfoBlockWrapper = styled('div')({
  position: 'sticky',
  top: 0,
  zIndex: 10,
});

const StyledDescriptionWrapper = styled('div')({
  marginBottom: 40,
});

function RequestMedicalRecordsPage(): JSX.Element {
  return (
    <StyledContainer disableGutters>
      <Grid container spacing={6}>
        <Grid size={9}>
          <StyledDescriptionWrapper>
            <StyledGridWrapper>
              <Description title="Patient Medical Records Order" />
            </StyledGridWrapper>
          </StyledDescriptionWrapper>
          <MedicalRecordsRequestForm />
        </Grid>
        <Grid size={3}>
          <StyledGridWrapper>
            <StyledInfoBlockWrapper>
              <InfoBlock />
            </StyledInfoBlockWrapper>
          </StyledGridWrapper>
        </Grid>
      </Grid>
    </StyledContainer>
  );
}

export default RequestMedicalRecordsPage;
